<template>
    <section class="our-articles">
        <news-heading :subtitle="true" id="external" :noMargin="true">More News</news-heading>
        <div class="our-articles-container">
            <div v-masonry transition-duration="0.3s" item-selector=".item">
                <news-common v-masonry-tile v-for="article in articles" :article="article" :key="article.id"></news-common>
            </div>
            <div v-if="articles.length" class="news-button-container">
                <button @click="nextPage" class="news-button" v-if="!finished">
                    Show More
                    <loading-icon v-if="loading"></loading-icon>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
	import NewsHeading from "./news-heading.vue";
	import LoadingIcon from "./loading-icon.vue";
	import NewsCommon from "./news-common.vue";

	export default {
		components: {
			NewsHeading,
			LoadingIcon,
			NewsCommon
		},
		props: [
		    "articles",
            "loading",
            "nextPage",
            "finished"
        ]
	}
</script>

<style lang="scss" scoped>
    .our-articles {
        width: 100%;
        margin-bottom: 2rem;
        position: relative;
        border-radius: 5px;
        img {
            box-shadow: 0 0 6px 1px rgba(0,0,0,0.5);
        }
    }

    .news-button-container {
        display: flex;
        padding: 2rem 1rem;
        width: 100%;
    }

    .news-button {
        background-color: #577f40;
        box-shadow: 1px 1px 2px 2px rgba(0,0,0,.3);
        color: white;
        width: 100%;
        padding: 1rem .5rem;
        font-size: 1.5rem;
    }
</style>


// WEBPACK FOOTER //
// our-articles.vue?1039dc78